import axios from 'axios';

function Client({ url, body, state, blob }) {
  const userState = state ? state.auth.data : {};

  const options = {};
  if (userState.token) {
    options.authorization = userState.token;
  }

  return new Promise((resolve, reject) => {
    return axios({
      url,
      method: 'POST',
      headers: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...options,
      },
      data: body,
      responseType: blob ? 'blob' : 'json',
    })
      .then((response) => {
        if (response.status !== 200) {
          return reject(response.data);
        }
        return resolve(response);
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 401) {
          window.location = '/auth';
          return;
        }
        return reject(error);
      });
  });
}
export default Client;
